import { useEffect, useState } from "react";
import { useDebounce } from "../../../shared/hooks";
import { ComissionServices } from "../../../shared/services/api/comission/ComissionServices";

export interface ComissionItem {
	id: string;
	clientId: string;
	clientName: string;
	clientDocument: string;
	proposalCertificateNumber: string | null;
	proposalName: string | null;
	type: string;
	installmentValue: string;
	value: string;
	dueDate: string;
	installmentNumber?: number;
	proposalRentMonthsCount?: number;
	proposalDocument?: string;
	status: string;
	description?: string;
}

export function useComissions(open: boolean, comissionId: string, dataIni: string, dataFim: string) {
	const [rows, setRows] = useState<ComissionItem[]>([]);
	const [isLoading, setIsLoading] = useState(false);
	const { debounce } = useDebounce();

	useEffect(() => {
		if (open && comissionId) {
			setIsLoading(true);
			debounce(() => {
				ComissionServices.getComissionValuesDetail(comissionId, dataIni, dataFim).then((result) => {
					if (result instanceof Error) {
						console.error("Erro ao buscar comissões:", result.message);
						setRows([]);
					} else {
						const formatted = Array.isArray(result.results)
							? result.results.map((item: any) => ({
									id: item.id,
									clientId: item.clientId,
									clientName: item.clientName,
									clientDocument: item.clientDocument,
									proposalCertificateNumber: item.proposalCertificateNumber ?? null,
									proposalName: item.proposalName ?? null,
									type: item.type,
									installmentValue: item.installmentValue,
									value: item.value,
									dueDate: item.dueDate,
									installmentNumber: item.installmentNumber,
									proposalRentMonthsCount: item.proposalRentMonthsCount,
									proposalDocument: item.proposalDocument,
									status: item.status,
									description: item.description ?? "",
							  }))
							: [];

						setRows(formatted);
					}
					setIsLoading(false);
				});
			});
		}
	}, [open, comissionId, dataIni, dataFim]);

	return { rows, isLoading };
}
